/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AvailableUpdateUpgradeResponseDto,
  ErrorResponseOfPtw100BadGatewayException,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100InternalServerException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100ServiceUnavailableException,
  ErrorResponseOfPtw100UnauthorizedException,
  RunUpdateUpgradeRequestDto,
  UpdateUpgradeStartResponseDto,
  UpdateUpgradeStatusDto,
} from '../models/index';
import {
    AvailableUpdateUpgradeResponseDtoFromJSON,
    AvailableUpdateUpgradeResponseDtoToJSON,
    ErrorResponseOfPtw100BadGatewayExceptionFromJSON,
    ErrorResponseOfPtw100BadGatewayExceptionToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100InternalServerExceptionFromJSON,
    ErrorResponseOfPtw100InternalServerExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON,
    ErrorResponseOfPtw100ServiceUnavailableExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    RunUpdateUpgradeRequestDtoFromJSON,
    RunUpdateUpgradeRequestDtoToJSON,
    UpdateUpgradeStartResponseDtoFromJSON,
    UpdateUpgradeStartResponseDtoToJSON,
    UpdateUpgradeStatusDtoFromJSON,
    UpdateUpgradeStatusDtoToJSON,
} from '../models/index';

export interface RunUpdateUpgradeRequest {
    runUpdateUpgradeRequestDto?: RunUpdateUpgradeRequestDto;
}

/**
 * 
 */
export class PtwEdgeUpdateApi extends runtime.BaseAPI {

    /**
     * Checks whether a new update or upgrade is available.
     */
    async checkForNewUpdatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/ptwedge-update`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => AvailableUpdateUpgradeResponseDtoFromJSON(jsonValue), "AvailableUpdateUpgradeResponseDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ServiceUnavailableException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => AvailableUpdateUpgradeResponseDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Checks whether a new update or upgrade is available.
     */
     async checkForNewUpdates(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<PtwEdgeUpdateApi['checkForNewUpdatesRaw']>>, AvailableUpdateUpgradeResponseDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = AvailableUpdateUpgradeResponseDto;

         const response = this.checkForNewUpdatesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Starts the requested update or upgrade.
     */
    async runUpdateUpgradeRaw(requestParameters: RunUpdateUpgradeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/ptwedge-update/start-update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunUpdateUpgradeRequestDtoToJSON(requestParameters['runUpdateUpgradeRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStartResponseDtoFromJSON(jsonValue), "UpdateUpgradeStartResponseDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadGatewayException" as const);
					}
          case 503: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ServiceUnavailableException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStartResponseDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Starts the requested update or upgrade.
     */
     async runUpdateUpgrade(requestParameters: RunUpdateUpgradeRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<PtwEdgeUpdateApi['runUpdateUpgradeRaw']>>, UpdateUpgradeStartResponseDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = UpdateUpgradeStartResponseDto;

         const response = this.runUpdateUpgradeRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Synchronizes and returns the state of the running update or upgrade.
     */
    async syncUpdateUpgradeStateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/ptwedge-update/sync-state`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStatusDtoFromJSON(jsonValue), "UpdateUpgradeStatusDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 500: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100InternalServerExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100InternalServerException" as const);
					}
          case 502: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadGatewayExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadGatewayException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => UpdateUpgradeStatusDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Synchronizes and returns the state of the running update or upgrade.
     */
     async syncUpdateUpgradeState(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<PtwEdgeUpdateApi['syncUpdateUpgradeStateRaw']>>, UpdateUpgradeStatusDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = UpdateUpgradeStatusDto;

         const response = this.syncUpdateUpgradeStateRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
